// extracted by mini-css-extract-plugin
export default {"retBarcodeContainer":"RET_retBarcodeContainer__Bfm4l","placeHolder":"RET_placeHolder__7Le2a"};